import Storage from './Storage';

export default class Ripple {

    /**
     * Class to add ripple.
     * @param {string} className Selector class.
     */
    constructor( className = 'js-ripple' ) {

        if ( !className ) {
            return;
        }

        const elements = document.getElementsByClassName( className );

        // Return when no elements.
        if ( !elements ) {
            return;
        }

        this.storage = new Storage();

        let self = this;
        Array.prototype.forEach.call( elements, function ( el ) {

            if ( el.classList.contains( 'no-ripple' ) ) {
                return;
            }

            // @since 1.0.3
            el.addEventListener( 'click', function ( event ) {
                let rippleColor = 'rgba(0,0,0,.15)';
                let rippleOpacity = 1;
                if ( el.classList.contains( 'btn-outline' ) ) {
                    if ( !!el.classList.contains( 'btn-primary' ) ) {
                        rippleColor = 'var(--btn_primary-background, var(--color-primary))';
                    }
                    if ( !!el.classList.contains( 'btn-secondary' ) ) {
                        rippleColor = 'var(--btn_secondary-background, var(--color-secondary))';
                    }
                    if ( !!el.classList.contains( 'btn-tertiary' ) ) {
                        rippleColor = 'var(--btn_tertiary-background, var(--color-tertiary))';
                    }

                    rippleOpacity = '0.25';
                }

                self.ripple( event, rippleColor, rippleOpacity );

                // When link, proceed to the URL.
                if ( el.href ) {

                    // Check for target. Default the `target` property isn't set.
                    if ( el.target && '_blank' === el.target ) {
                        // Open new window.
                        window.open( el.href );

                        // Return true for submit-buttons. @source: https://developer.mozilla.org/en-US/docs/Web/API/Event/returnValue
                        event.returnValue = true;
                        return true;
                    }

                    // Same window.
                    window.location = el.href;

                    // Return true for submit-buttons. @source: https://developer.mozilla.org/en-US/docs/Web/API/Event/returnValue
                    event.returnValue = true;
                    return true;
                }

                // @since 1.0.12
                if ( 'submit' === el.type ) {
                    const form = event.target.form;
                    if ( form && form.checkValidity() ) {
                        form.submit();
                    }
                }

                // Return true for submit-buttons. @source: https://developer.mozilla.org/en-US/docs/Web/API/Event/returnValue
                event.returnValue = true;
                return true;
            } );

            // @since 1.0.4
            el.addEventListener( 'mouseenter', function ( event ) {
                let rippleColor = 'rgba(255,255,255,.15)';
                if ( el.classList.contains( 'btn-outline' ) ) {
                    if ( !!el.classList.contains( 'btn-primary' ) ) {
                        rippleColor = self.getVariableTint( '--btn_primary-background', 'btn-primary' );
                    }
                    if ( !!el.classList.contains( 'btn-secondary' ) ) {
                        rippleColor = self.getVariableTint( '--btn_secondary-background', 'btn-secondary' );
                    }
                    if ( !!el.classList.contains( 'btn-tertiary' ) ) {
                        rippleColor = self.getVariableTint( '--btn_tertiary-background', 'btn-tertiary' );
                    }
                }
                self.ripple( event, rippleColor );
            } );
        } );
    }

    /**
     * Create ripple within selected element.
     *
     * @param event mouseevent.
     * @param rippleColor color of the ripple.
     * @param rippleOpacity opacity of the ripple.
     * @since 1.0.3
     * @return {boolean}
     */
    ripple( event, rippleColor = 'rgba(0,0,0,.15)', rippleOpacity = 1 ) {
        event.preventDefault();

        const el = event.currentTarget;

        if ( document.getElementById( 'ripple' ) ) {
            document.getElementById( 'ripple' ).parentNode.removeChild( document.getElementById( 'ripple' ) );
        }

        const diameter = Math.max( el.clientWidth, el.clientHeight );
        const radius = diameter / 2;
        const rect = el.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;

        // Set CSS properties to the Button.
        const ripple = document.createElement( 'div' );
        el.appendChild( ripple );

        // Set CSS variables to the parent of the ripple.
        el.style.setProperty( '--ripple-d', `${ diameter }px` );
        el.style.setProperty( '--ripple-y', `${ y - radius }px` );
        el.style.setProperty( '--ripple-x', `${ x - radius }px` );
        el.style.setProperty( '--ripple-bg', rippleColor );
        el.style.setProperty( '--ripple-opacity', rippleOpacity );

        ripple.id = 'ripple';
        ripple.classList.add( 'ripple' );
    }

    /**
     * Looking for the value behind the value and store temporary.
     *
     * @param {string} variableKey Name of the CSS variable, eq: --btn_primary-background.
     * @param {string} buttonName Button variant, eq: .btn-primary.
     * @return {string}
     */
    getVariableTint( variableKey, buttonName ) {
        const storedValue = this.storage.get( `${ buttonName }-ripple` );
        if ( !!storedValue ) {
            return storedValue;
        }

        const styleSheet = Array.from( document.styleSheets )?.filter( ( f ) => f?.ownerNode?.id === 'gutenkit-customizer-css' ); //[0].cssRules[0];
        const styleGroups = Array.from( styleSheet[ styleSheet.length - 1 ].cssRules )?.filter( ( s ) => s?.selectorText === ':root' );

        styleGroups?.forEach( group => {
            const index = Array.from( group?.style ).indexOf( variableKey );
            if ( -1 !== index ) {
                let cssText = group.cssText.replaceAll( ' ', '' );
                Array.from( cssText.substring( 6, cssText.length - 1 ).split( ";" ) ).forEach( line => {
                    if ( line.length > 0 ) {
                        const chunks = line.split( ":" );
                        if ( variableKey === chunks.shift() ) {
                            const value = chunks[ chunks.length - 1 ];
                            if ( !!value ) {
                                const cssToken = value.substring( 4, value.length - 1 );
                                // getComputedStyle will return the # value. Not  another CSS property.
                                this.storage.set( `${ buttonName }-ripple`, getComputedStyle( document.documentElement ).getPropertyValue( `${ cssToken }-tint` ) );
                                return true;
                            }
                        }
                    }
                } );
            }
        } );
    }
}
